
    import {defineComponent, reactive, computed, ComputedRef, watch} from 'vue'
    import {useRoute} from "vue-router";

    // interface State {
    // }
    export default defineComponent({
        name: "explainFreeCheck",
        setup() {
            // let state: State = reactive({
                
            // })
            const {query} = useRoute();
            // if (state.reportMsg['Rp299']() || state.reportMsg['RpZB']() || state.reportMsg['RpSRZ']()) {
            //     state.reportTemplate = '299'
            // }
            window.scrollTo(0,0);
            return {
                // state
            }
        },
        methods: {
            goBack(){
                history.go(-1)
            },
        }
    })
